import React from 'react';  
  
const Pagination = ({ currentPage, totalPages, onPageChange }) => {  
  const pages = [];  
  const maxVisiblePages = 5;  
  
  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));  
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);  
  
  if (endPage - startPage < maxVisiblePages - 1) {  
    startPage = Math.max(1, endPage - maxVisiblePages + 1);  
  }  
  
  for (let i = startPage; i <= endPage; i++) {  
    pages.push(i);  
  }  
  
  return (  
    <div className="pagination">  
      <button  
        onClick={() => onPageChange(currentPage - 1)}  
        disabled={currentPage === 1}  
      >  
        Previous  
      </button>  
  
      {startPage > 1 && (  
        <>  
          <button onClick={() => onPageChange(1)}>1</button>  
          {startPage > 2 && <span style={{ color: 'var(--text-secondary)' }}>...</span>}  
        </>  
      )}  
  
      {pages.map((page) => (  
        <button  
          key={page}  
          onClick={() => onPageChange(page)}  
          className={currentPage === page ? 'active' : ''}  
        >  
          {page}  
        </button>  
      ))}  
  
      {endPage < totalPages && (  
        <>  
          {endPage < totalPages - 1 && <span style={{ color: 'var(--text-secondary)' }}>...</span>}  
          <button onClick={() => onPageChange(totalPages)}>{totalPages}</button>  
        </>  
      )}  
  
      <button  
        onClick={() => onPageChange(currentPage + 1)}  
        disabled={currentPage === totalPages}  
      >  
        Next  
      </button>  
    </div>  
  );  
};  
  
export default Pagination;  

